import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { rootCssSet } from "../../utils/helpers/common";

const initialState = {
  rootFix: false,
  homePageFilter: false,
  resetFilter: false,
  resetList: false,
  referralActionData: {
    id: "",
    list_id: "",
    name: "",
    type: "",
  },
  addAgentsDialogBox: false,
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setRootCss: () => {
      let root = document.getElementById("root");

      if (root?.classList.contains("root-overflow-hidden")) {
        root?.classList.remove("root-overflow-hidden");
      } else {
        root?.classList.add("root-overflow-hidden");
      }
    },
    setHomePageFilter: (state) => {
      state.homePageFilter = !state.homePageFilter;
      rootCssSet();
    },

    resetFilter: (state) => {
      state.resetFilter = !state.resetFilter;
    },

    resetList: (state) => {
      state.resetList = !state.resetList;
    },

    setReferralActionData: (state, action) => {
      state.referralActionData = action?.payload;
    },

    addAgentsDialogBox: (state) => {
      state.addAgentsDialogBox = !state.addAgentsDialogBox;
    },
  },
});

export const commonAction = commonSlice.actions;
export const commonReducer = commonSlice.reducer;
